import { render, staticRenderFns } from "./aboutCards.vue?vue&type=template&id=10fa169a&"
import script from "./aboutCards.vue?vue&type=script&lang=js&"
export * from "./aboutCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports